<template>
    <div class="photo-list">
     <br /><br />
    <v-container>
        <v-row align="center">
            <v-col cols="12" md="10">
            <v-text-field v-model="title" label="Search by Title"></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
            <v-btn :dark="$vuetify.theme.dark" small @click="searchTitle">
                Search
            </v-btn>
            </v-col>

            <v-col cols="12" sm="12">
            <v-card class="mx-auto" tile>
                <v-card-title>My images</v-card-title>
                
                <v-data-table
                :headers="headers"
                :items="images"
                disable-pagination
                :hide-default-footer="false"
                >
                <template v-slot:[`item.display`]="{ item }">
                    <v-img :src="item.thumbnail" class="thumbnail"/>
                </template>   
                <template v-slot:[`item.actions`]="{ item }">
                    <router-link :to="{ name: 'image' , params: { id: item.user, image_id: item.pk, edit:true }}">
                        <v-btn :dark="$vuetify.theme.dark" small >
                        <v-icon small class="mr-2">mdi-pencil</v-icon> Edit
                    </v-btn>
                    </router-link>
                    <v-btn :dark="$vuetify.theme.dark" small @click="deleteImage(item)">
                        <v-icon small class="mr-2">mdi-delete</v-icon> Delete
                    </v-btn>
                
                </template>
                </v-data-table>

                <!-- <v-card-actions v-if="images.length > 0">
                <v-btn :dark="$vuetify.theme.dark" small color="error">
                    Remove All
                </v-btn>
                </v-card-actions> -->
            </v-card>
            </v-col>
        </v-row>
    </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default { 
        name: 'PhotoList',
        components: {   
        },
        data() {
            return {
                tutorials: [],
                title: "",
                headers: [
                    { text: "thubmnail", value: "display"},
                    { text: "Title", align: "start", sortable: true, value: "title" },
                    { text: "Description", value: "description", sortable: false },
                    { text: "Status", value: "status", sortable: false },
                    { text: "Actions", value: "actions", sortable: false },
                ],
                isEditing: true,
                checkbox: []
            }
        },
        computed: {
            ...mapGetters(
                { isAuthenticated: 'auth/isAuthenticated' }
            ),
            ...mapState({
                 username: state => state.user.identity.username
            }),
            filteredByUser() {
                return this.$store.getters['image/filteredByUser']
            },
            images() {
              return this.filteredByUser(this.username)
            }
        },
        methods: {
            searchTitle() {
                
            },
            deleteImage(image) {
                image.deleted = true
                this.$store.dispatch('image/updateImage', image, 'deleted')
            }
        },
        mounted() {
            this.filteredByUser(this.username)
        }

    }
</script>

<style scoped>



.thumbnail {
    width: 150px;
}
</style>